var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMirrage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5388 145.793C85.7792 145.793 99.7553 131.817 99.7553 114.577C99.7553 97.3362 85.7792 83.3601 68.5388 83.3601C51.2984 83.3601 37.3223 97.3362 37.3223 114.577C37.3223 131.817 51.2984 145.793 68.5388 145.793Z",
    fill: "white",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5387 132.705C78.5509 132.705 86.6674 124.589 86.6674 114.577C86.6674 104.564 78.5509 96.4479 68.5387 96.4479C58.5264 96.4479 50.4099 104.564 50.4099 114.577C50.4099 124.589 58.5264 132.705 68.5387 132.705Z",
    fill: "white",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.072 75.7313C96.3989 71.3238 79.308 81.2576 74.9005 97.9171C70.493 114.59 80.4267 131.681 97.0863 136.089C113.759 140.496 130.85 130.562 135.258 113.903C139.665 97.2297 129.732 80.1388 113.072 75.7313ZM122.601 110.547C120.04 120.224 110.12 125.993 100.429 123.432C90.7514 120.871 84.9825 110.951 87.5435 101.26C90.1044 91.5822 100.025 85.8133 109.716 88.3743C119.393 90.9352 125.162 100.855 122.601 110.547Z",
    fill: "white",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.42 64.598L113.544 73.9522L99.1622 55.0012L120.27 48.5719L135.42 64.598Z",
    fill: "white",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.248 53.0737L150.314 49.2997",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.477 77.0927L144.302 82.3224",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144.976 65.5549L151.378 67.2398",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7225 40.4847L93.3259 34.2036",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9722 63.7218L82.2059 65.8784",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9157 50.971L83.5133 49.2727",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirrage);
export default __webpack_public_path__ + "static/media/mirrage.e931f5869cd76a30ad7b8282c45fad6e.svg";
export { ForwardRef as ReactComponent };